var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoginPlant = function SvgLoginPlant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122,
    height: 146,
    viewBox: "0 0 122 146"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bed3c3",
    d: "M26.944 149.456s.506-.28 1.422-.836c.73-.444 1.732-1.064 2.943-1.856 10.832-7.066 38.898-27.85 50.482-59.95 14.492-40.192-2.347-82.9-2.347-82.9S42.366 24.55 26.53 61.664a83.796 83.796 0 0 0-1.93 4.893c-12.612 34.97-1.5 71.845 1.597 80.834.466 1.346.748 2.065.748 2.065z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454154",
    d: "M6.073 72.07C29.651 107.694 23.19 153 23.19 153s-44.686-12.448-68.263-48.07C-68.651 69.306-62.19 24-62.19 24s44.686 12.448 68.263 48.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008689",
    d: "M23.007 155s.569-.09 1.617-.302c.836-.169 1.987-.41 3.392-.743 12.562-2.953 45.962-12.935 67.798-39.18C123.144 81.914 121.994 36 121.994 36s-41.79 6.77-69.325 36.28a84.084 84.084 0 0 0-3.483 3.944c-23.78 28.594-25.998 67.067-26.173 76.578-.025 1.425-.006 2.198-.006 2.198z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#454154",
    d: "M35.275 72.976c-16.857 39.35-2.578 83.124-2.578 83.124s41.61-20.022 58.467-59.371C108.02 57.38 93.74 13.605 93.74 13.605s-41.61 20.022-58.466 59.371z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M23 151.432c.635.732 1.195 1.358 1.656 1.87 1.021 1.114 1.6 1.698 1.6 1.698s.704-.846 1.887-2.43c6.493-8.662 27.381-39.46 25.769-75.036a89.49 89.49 0 0 0-.43-5.534 84.132 84.132 0 0 0-3.58 3.89C25.46 104.097 23.181 142.05 23 151.432z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008689",
    fillRule: "nonzero",
    d: "M-10.916 78.808C-9.088 121.61 22.31 155 22.31 155s28.433-36.006 26.606-78.808C47.088 33.39 15.69 0 15.69 0s-28.433 36.006-26.606 78.808z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#454154",
    d: "M21 153 14 1"
  }))));
};
export default SvgLoginPlant;